import { CartActionType } from './action.type';

export const CartActions = {
    async [CartActionType.SelectedCart]({commit}, cartSelected) {
        commit(CartActionType.SelectedCart, cartSelected);
    },
}